import React from 'react';
import { Link } from 'react-router-dom';
import { Formatters, Messages } from '../../../../../gen-src/Localize';
import { SvgPrepFlowAnnotationsFilter } from '../../../../../gen-src/icons';
import { classes } from '../../../data-catalog-shared';

import {
  anchoredContentInfoItemClass,
  AnchoredLineageItemContainer,
  anchorNameClass,
  boldLineageItemClass,
  filteredOnItemIndicatorClass,
  LineageContentInfoItemAnchorRow,
  LineageContentInfoItemAnchorRowSelected,
} from '../style/LineageCartoucheStyles';
import { LineageIconButton } from './LineageIconButton';
import { LineageItemType } from './LineageItemType';

export interface LineageAnchorProps {
  readonly anchorName: string | null;
  readonly selectedItemCount: number;
  readonly label: string;
  readonly lineageItemType: LineageItemType;
  readonly isCurrentPane: boolean;
  readonly linkHref: string;
  readonly buttonAltText: string;
  readonly isFilteredOnThisType: boolean;
  readonly anchorCount: number | null;
}

const selectedMessagesForAnchorType: Record<LineageItemType, (a: { COUNT: number, COUNT_LOC: string }) => string> = {
  dashboard: Messages.XFieldSelected,
  database: Messages.XTableSelected,
  datasource: Messages.XFieldSelected,
  flow: Messages.XFieldSelected,
  lens: Messages.XFieldSelected,
  metric: () => '', // We don't have a metrics lineage page yet. This should change if we get one
  sheet: Messages.XFieldSelected,
  table: Messages.XColumnSelected,
  user: () => '', // We don't have a user lineage page yet. This should change if we get one
  virtualConnection: Messages.XTableSelected,
  virtualConnectionTable: Messages.XColumnSelected,
  workbook: Messages.XFieldSelected,
};

export function LineageAnchor(props: LineageAnchorProps) {
  const anchorName = props.anchorName ? props.anchorName : Messages.PermissionsRequired();

  return (
    <AnchoredLineageItemContainer>
      <LineageIconButton
        isCurrentPane={props.isCurrentPane}
        linkHref={props.linkHref}
        lineageItemType={props.lineageItemType}
        buttonAltText={props.buttonAltText}
      />
      <Link to={props.linkHref} className={anchoredContentInfoItemClass}>
        <LineageContentInfoItemAnchorRow>
          <span className={classes(anchorNameClass, props.isCurrentPane && boldLineageItemClass)} title={anchorName}>
            {anchorName}
          </span>
        </LineageContentInfoItemAnchorRow>
        <LineageContentInfoItemAnchorRow>
          <span className={classes(props.isCurrentPane && boldLineageItemClass)}>{props.label} {props.anchorCount}</span>
          {props.isFilteredOnThisType
            ? (
              <LineageContentInfoItemAnchorRowSelected>
                <SvgPrepFlowAnnotationsFilter className={filteredOnItemIndicatorClass} />
                <span>{selectedMessagesForAnchorType[props.lineageItemType]({
                  COUNT: props.selectedItemCount,
                  COUNT_LOC: Formatters.formatCount(props.selectedItemCount)
                })}</span>
              </LineageContentInfoItemAnchorRowSelected>
            )
            : null}
        </LineageContentInfoItemAnchorRow>
      </Link>
    </AnchoredLineageItemContainer>
  );
}

